import { render, staticRenderFns } from "./NamePopModal.vue?vue&type=template&id=1485e992"
import script from "./NamePopModal.vue?vue&type=script&lang=js"
export * from "./NamePopModal.vue?vue&type=script&lang=js"
import style0 from "./NamePopModal.vue?vue&type=style&index=0&id=1485e992&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports